import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import React, {useEffect} from "react";

interface TermItem {
  number: string;
  title?: string;
  content: string;
  subItems?: TermItem[];
}



const termsData: TermItem[] = [
    {
        "number": "1",
        "title": "About these terms",
        "content": "",
        "subItems": [
            {
                "number": "1.1",
                "content": "These terms govern your access to and use of the Vinimark Trading Proprietary Limited website (herein \"Website\")."
            },
            {
                "number": "1.2",
                "content": "By using the Website, you agree to the terms of use set out in this document (herein \"Terms\")."
            },
            {
                "number": "1.3",
                "content": "If you do not agree to these Terms, or are not legally capable of doing so, you may not use the Website or any part thereof."
            },
            {
                "number": "1.4",
                "content": "The Terms may be amended from time to time, with the revised terms taking effect upon publication. Your continued use of the Website signifies your agreement to the revised Terms, and it is your responsibility to review said revised Terms periodically and remain informed of any changes."
            },
            {
                "number": "1.5",
                "content": "Should you not agree to any revised Terms, you must immediately cease accessing the Website."
            },
            {
                "number": "1.6",
                "content": "The Terms contain provisions that may limit your rights at law, or place additional obligations on you, some of which may be onerous. While you should have regard to all of the terms of the Terms, we have endeavoured to highlight these provisions by bolding the relevant text. Your attention is specifically drawn to clause 8 (Third-Party Content) and clause 9 (Disclaimers, limitations of liability and indemnities)."
            }
        ]
    },
    {
        "number": "2",
        "title": "About us",
        "content": "",
        "subItems": [
            {
                "number": "2.1",
                "content": "The Website is made available by Vinimark Trading Proprietary Limited, a private company duly incorporated in terms of the laws of the Republic of South Africa with registration number 1987/000032/07 and with the following further details:",
                "subItems": [
                    {
                        "number": "2.1.1",
                        "content": "physical address: 5 Herold Street, Stellenbosch, Western Cape, 7600, South Africa"
                    },
                    {
                        "number": "2.1.2",
                        "content": "email address: info@vinimark.co.za"
                    }
                ]
            }
        ]
    },
    {
        "number": "3",
        "title": "No offer",
        "content": "",
        "subItems": [
            {
                "number": "3.1",
                "content": "The information contained on our Website is for general information purposes only and not intended to constitute an offer to do business or to sell any goods or services. If you are interested in doing business with us, you are invited to contact us by using the contact information provided on the Website."
            }
        ]
    },
    {
        "number": "4",
        "title": "Promotion of alcohol",
        "content": "",
        "subItems": [
            {
                "number": "4.1",
                "content": "To the extent that this Website markets, promotes or advertises alcohol, it is not directed at persons under the age of 18 years."
            },
            {
                "number": "4.2",
                "content": "We support the responsible consumption of alcohol and comply with the principles and code of conduct administered by the Association for Alcohol Responsibility and Education. Further information regarding these initiatives is available at www.aware.org."
            }
        ]
    },
    {
        "number": "5",
        "title": "Restrictions on use",
        "content": "",
        "subItems": [
            {
                "number": "5.1",
                "content": "You may not, directly or indirectly:",
                "subItems": [
                    {
                        "number": "5.1.1",
                        "content": "attempt to circumvent or compromise any security measures of the Website;"
                    },
                    {
                        "number": "5.1.2",
                        "content": "place an unreasonable or disproportionate load on the Website by submitting a high volume of requests within a short period;"
                    },
                    {
                        "number": "5.1.3",
                        "content": "access the Website through automated means, except in the case of a bona fide search engine indexing publicly accessible pages;"
                    },
                    {
                        "number": "5.1.4",
                        "content": "use the Website in any way that infringes, misappropriates or violates any third-party rights;"
                    },
                    {
                        "number": "5.1.5",
                        "content": "restrict or inhibit the use of the Website by others;"
                    },
                    {
                        "number": "5.1.6",
                        "content": "use the Website to upload, post, transmit, or distribute any material that is obscene, threatening, violent, racist, defamatory, offensive, or otherwise unlawful."
                    }
                ]
            },
            {
                "number": "5.2",
                "content": "We reserve the right to take any action we deem necessary to maintain the security, integrity, and proper functioning of the Website."
            }
        ]
    },
    {
        "number": "6",
        "title": "Customer portal",
        "content": "",
        "subItems": [
            {
                "number": "6.1",
                "content": "In this clause, the following terms (as capitalised), shall have the meanings assigned below:",
                "subItems": [
                    {
                        "number": "6.1.1",
                        "content": "\"Authorised User\" means a person granted access to use the Customer Portal in accordance with these Terms;"
                    },
                    {
                        "number": "6.1.2",
                        "content": "\"Customer Code\" means the code and any other authentication information used by an Authorised User to access the Customer Portal;"
                    },
                    {
                        "number": "6.1.3",
                        "content": "\"Customer Portal\" means the online environment made available on the Website for use by Authorised Users."
                    }
                ]
            },
            {
                "number": "6.2",
                "content": "Access to the Customer Portal is restricted to Authorised Users. We may, in our sole discretion, grant or revoke access without notice."
            },
            {
                "number": "6.3",
                "content": "Authorised Users are responsible for the security and confidentiality of their Customer Code, and may not:",
                "subItems": [
                    {
                        "number": "6.3.1",
                        "content": "disclose the Customer Code to any third party;"
                    },
                    {
                        "number": "6.3.2",
                        "content": "permit any unauthorised person to access the Customer Portal."
                    }
                ]
            },
            {
                "number": "6.4",
                "content": "Authorised Users agree to notify us immediately of any unauthorised access to or use of their Customer Code, or any other breach of security in relation to the Customer Portal."
            }
        ]
    },
    {
        "number": "7",
        "title": "Intellectual property rights",
        "content": "",
        "subItems": [
            {
                "number": "7.1",
                "content": "For purposes of these Terms, the term \"Intellectual Property\" includes, without limitation, all intellectual property and similar proprietary rights, howsoever arising and in whatever tangible or intangible media, whether or not registered, including (without limitation) copyright, database rights, patents, trade marks, registered designs, unregistered design rights, domain names, confidential information, business processes, trade secrets, know-how, goodwill, and any applications for the protection or registration of those rights and all renewals and extensions thereof throughout the world (if applicable), as well as any adaptations, derivatives, and embodiments of the aforegoing."
            },
            {
                "number": "7.2",
                "content": "The Intellectual Property contained in this Website is owned by or licensed to us. You are authorised to view the content published on this Website but for no other reason whatsoever."
            },
            {
                "number": "7.3",
                "content": "All rights not expressly granted are reserved and no right, title, or interest in any Intellectual Property vesting in this Website is granted to you."
            }
        ]
    },
    {
        "number": "8",
        "title": "Third-Party Content",
        "content": "",
        "subItems": [
            {
                "number": "8.1",
                "content": "We may provide links to third-party websites and content (herein \"Third-Party Content\") on this Website."
            },
            {
                "number": "8.2",
                "content": "You hereby acknowledge and agree that such Third-Party Content is outside of our control and accordingly, that we shall not have any duty or liability in respect thereof. When you access Third-Party Content, you do so at your own risk."
            },
            {
                "number": "8.3",
                "content": "You acknowledge and agree that we will not be held liable, directly or indirectly, for the information provided by Third-Party Content nor for any loss or damage resulting from your access to and use of the Third-Party Content."
            }
        ]
    },
    {
        "number": "9",
        "title": "Disclaimers, limitations of liability and indemnities",
        "content": "",
        "subItems": [
            {
                "number": "9.1",
                "content": "While we take reasonable steps to ensure the quality and accuracy of the Website, we make no warranty or representation, express or implied, concerning the content of the Website, which is provided as is."
            },
            {
                "number": "9.2",
                "content": "Specifically, and to the maximum extent possible under applicable law, we do not warrant or represent:",
                "subItems": [
                    {
                        "number": "9.2.1",
                        "content": "that this Website will be error-free;"
                    },
                    {
                        "number": "9.2.2",
                        "content": "that this Website will always be accessible;"
                    },
                    {
                        "number": "9.2.3",
                        "content": "that the information contained on this Website is completely accurate or correct."
                    }
                ]
            },
            {
                "number": "9.3",
                "content": "To the maximum extent permitted by applicable law, we will not be liable for any claim, cost, expense, penalty, damage, injury or any other adverse consequence arising from your use of this Website."
            },
            {
                "number": "9.4",
                "content": "To the maximum extent permitted by applicable law, you agree to indemnify us from any claim, cost, expense, penalty, damage, injury or any other adverse consequence arising from your breach of these Terms."
            }
        ]
    },
    {
        "number": "10",
        "title": "Termination",
        "content": "",
        "subItems": [
            {
                "number": "10.1",
                "content": "We reserve the right to take any action we deem necessary to maintain the security, integrity, and proper functioning of the Website."
            },
            {
                "number": "10.2",
                "content": "We may, in our sole discretion, terminate or suspend your access to the Website without notice, including (without limitation) if:",
                "subItems": [
                    {
                        "number": "10.2.1",
                        "content": "you breach any of these Terms;"
                    },
                    {
                        "number": "10.2.2",
                        "content": "we are required to do so under applicable law."
                    }
                ]
            }
        ]
    },
    {
        "number": "11",
        "title": "Notices and address for service",
        "content": "",
        "subItems": [
            {
                "number": "11.1",
                "content": "Each of us hereby choose as its address for service and receipt of notices (i.e. domicilia citandi et executandi) for purposes under these Terms, whether in respect of judiciary process or otherwise, our nominated physical address or email address (herein each a \"Notice Address\") being in our case of the details provided in these Terms and in your case the current Notice Address(es) you may provide to us. Accordingly, insofar as these Terms may prescribe notice periods for the giving of notices, such notice periods shall be complied with upon the giving of notices in compliance with the terms of this clause 11."
            },
            {
                "number": "11.2",
                "content": "Any notice served on a Notice Address before 17h00 in the recipient's time zone shall:",
                "subItems": [
                    {
                        "number": "11.2.1",
                        "content": "if delivered by hand, be deemed to have been received on the day of delivery;"
                    },
                    {
                        "number": "11.2.2",
                        "content": "if sent by email, be deemed to have been received on the date when it is capable of retrieval by the recipient."
                    }
                ]
            },
            {
                "number": "11.3",
                "content": "In the event of delivery of a notice to a Notice Address later than 17h00 in the recipient’s time zone, then delivery shall be deemed to have taken place on the next day."
            },
            {
                "number": "11.4",
                "content": "A delivery or read receipt generated by a sender's email client shall constitute face value (i.e. prima facie) proof of the message being capable of retrieval by the recipient."
            }
        ]
    },
    {
        "number": "12",
        "title": "Interpretation",
        "content": "",
        "subItems": [
            {
                "number": "12.1",
                "content": "For purposes of these Terms:",
                "subItems": [
                    {
                        "number": "12.1.1",
                        "content": "the rule of interpretation that a contract will be interpreted against the party responsible for the drafting and preparation thereof will not apply;"
                    },
                    {
                        "number": "12.1.2",
                        "content": "unless the context shows otherwise, a clause which includes a specific example or examples will not be construed as limiting the meaning of the general wording preceding it;"
                    },
                    {
                        "number": "12.1.3",
                        "content": "the termination or expiry of these Terms will not affect those provisions which expressly provide that they will continue to operate after such termination or expiry, or those provisions which of necessity must continue to have effect after such termination or expiry, even where those clauses do not expressly provide for this."
                    }
                ]
            }
        ]
    },
    {
        "number": "13",
        "title": "General",
        "content": "",
        "subItems": [
            {
                "number": "13.1",
                "content": "Applicable law. These Terms shall be governed by and construed and interpreted in accordance with the laws of the Republic of South Africa. Unless and to the extent expressly agreed otherwise in these Terms, we agree that the High Court of South Africa, Western Cape Division, shall have exclusive jurisdiction to hear any disputes that may arise from these Terms."
            },
            {
                "number": "13.2",
                "content": "Whole agreement. These Terms constitute the whole agreement between us as to the subject matter hereof. None of us shall have any claim or right of action arising from any undertaking, representation or warranty not included in these Terms."
            },
            {
                "number": "13.3",
                "content": "Severability. Each provision of these Terms is severable from the other provisions. Should any provision be found by a court of competent jurisdiction to be invalid or unenforceable, then the remainder of these Terms will remain binding and continue with full force and effect."
            },
            {
                "number": "13.4",
                "content": "Cost of legal services. Each of us will pay our own costs and expenses incurred by us in connection with the negotiation, drafting, re-drafting, entering into and implementation of legally binding documents. Should any one of us instruct attorneys to take any steps to enforce any rights in terms of these Terms arising from a breach thereof, then the breaching party shall be liable for all legal and incidental costs, including legal fees on the attorney and own client scale, collection commission and tracing charge."
            }
        ]
    }
]


function Terms() {
    useEffect(() => {
        document.title = 'Vinimark | Terms of Use'
        window.scrollTo(0, 0);
    }, []);
    const renderTermItem = (item: TermItem, level: number = 0, parentSubItems?: TermItem[], itemIndex?: number): React.ReactNode => {
        const paddingLeft = level === 0 ? '0' : level === 1 ? '1.5em' : level === 2 ? '3em' : '4.5em';

        // Check if this is the first item in a submenu
        const isFirstInSubmenu = level > 0 && itemIndex === 0;

        // Check if this is the last item in a submenu
        const isLastInSubmenu = level > 0 && parentSubItems && itemIndex === parentSubItems.length - 1;

        // Calculate margins
        let marginTop = '0px';
        let marginBottom = '0px';

        if (level === 0) {
            marginTop = '20px'; // Main sections always have 20px top margin
        } else if (isFirstInSubmenu) {
            marginTop = '10px'; // First item in submenu gets 10px top margin
        }

        if (isLastInSubmenu) {
            marginBottom = '10px'; // Last item in submenu gets 10px bottom margin
        }

        return (
            <div key={`${item.number}-${level}`}>
                {item.title ? (
                    <p style={{ fontWeight: 400, marginTop: '20px', marginBottom: '0px' }}>
                        {item.number}.&nbsp;&nbsp;&nbsp;{item.title}
                    </p>
                ) : (
                    item.content && (
                        <div style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            fontWeight: 400,
                            paddingLeft,
                            marginTop,
                            marginBottom
                        }}>
                            <div style={{ minWidth: '1.5em' }}>{item.number}</div>
                            <div style={{ flex: 1, paddingLeft: '0.5em' }}>
                                {item.content}
                            </div>
                        </div>
                    )
                )}
                {item.subItems?.map((subItem, index) => renderTermItem(subItem, level + 1, item.subItems, index))}
            </div>
        );
    };

    useEffect(() => {
        document.title = 'Vinimark | Terms of Use'
    }, []);

    return (
        <div>
            <Header />
            <style>{`
                .form-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-top: 140px;

                }
                @media (min-width: 575px) {
                    .form-container {
                        flex-direction: row;
                        justify-content: center;
                        gap: 20px; /* spacing between items */
                    }
                }
                .content-form-field {
                    margin-bottom: 20px; /* 20px margin between inputs */
                    width: 100%;
                }
                .checkbox-container {
                    display: flex;
                    gap: 20px;
                    margin-top: 20px;
                }
                .checkbox-label {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    cursor: pointer;
                    user-select: none;
                }
                /* Put checkbox AFTER the label text */
                .checkbox-label input[type="checkbox"] {
                    order: 2;
                    margin-left: 4px;
                }
            `}</style>
            <div>
                <div className="form-container">
                    <div style={{ flex: 1 }}></div>
                    <div style={{ flex: 1, textAlign: "left" }}>
                        <div style={{ padding: window.innerWidth > 575 ? '0' : '20px', marginLeft: window.innerWidth > 575 ? '16px' : '20px', width: '60%', minWidth: '300px', textAlign: 'left' }}>
                            <p style={{ textTransform: 'uppercase', fontWeight: 600 }}>
                                Terms of use
                            </p>
                            {/*<p style={{ textTransform: 'uppercase', fontWeight: 400 }}>*/}
                            {/*    IMPORTANT NOTICE*/}
                            {/*</p>*/}
                            {/*<p style={{ textTransform: 'uppercase', fontWeight: 400 }}>*/}
                            {/*    BY USING OUR WEBSITE AT WWW.VINIMARK.CO.ZA YOU SIGNIFY THAT YOU HAVE READ, UNDERSTAND AND AGREE TO BE BOUND TO THESE TERMS OF USE. IF YOU DO NOT UNDERSTAND OR AGREE TO THESE TERMS, AS MAY BE AMENDED FROM TIME TO TIME, OR ARE NOT LEGALLY ENTITLED TO AGREE FOR ANY REASON, YOU MAY NOT ACCESS OR USE THIS WEBSITE. OUR TERMS OF USE CONTAIN IMPORTANT PROVISIONS THAT LIMIT YOUR DEFAULT RIGHTS AND OUR LIABILITY AT LAW. YOU SHOULD PAY PARTICULAR ATTENTION TO CAPITALISED TERMS.*/}
                            {/*</p>*/}
                            <p>Last Updated: 1 October 2025</p>

                            {termsData.map((item, index) => renderTermItem(item, 0, termsData, index))}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Terms;
